import React from "react"
import { BruciatoreDto } from "../../generated"
import BruciatoriStore from "../bruciatoriStore";

interface Props {
    id: number | undefined | null;
    template: (caldaia: BruciatoreDto) => JSX.Element | string | number;
}

export default ({ id, template }: Props) => {
    if (!id)
        return null;
    const item = BruciatoriStore.use(id)
    if (item == null) return null;
    return <>{template(item)}</>;
}
